export default class TaskBaseService {
	constructor(taskStateService) {
		this._taskStateService = taskStateService;
	}

	_mapState(task) {
		return task.state && this._taskStateService.mapState(task.state);
	}
}
